import appConfig from 'config';
import { session } from 'state/analytics/events/form';
import { SERVICES } from 'tenant/utils';

const getSegmentWebClient = () => {
  if (!window.analytics) {
    if (SERVICES.SEGMENT) console.warn('No Segment Snippet Loaded');
    return false;
  }
  return window.analytics;
};

const identify = (user) => {
  const SegmentClient = getSegmentWebClient();
  if (SegmentClient) {
    SegmentClient.identify(user.uuid, {
      userId: user.uuid,
      name: user.company_name,
      phone: user.phone,
      email: user.email,
      country: user.country,
      country_code: user.country,
    });
  } else {
    if (SERVICES.SEGMENT)
      console.warn('Cant identify, No Segment Snippet Loaded');
  }
};

const track = ({
  eventName,
  eventData,
  country,
  userId,
  anonymousId,
  ontruckUserId,
}) => {
  try {
    const SegmentClient = getSegmentWebClient();
    if (SegmentClient) {
      SegmentClient.track(eventName, {
        userId,
        anonymousId,
        event: eventName,
        userAgent: navigator.userAgent,
        appVersion: appConfig.APP_VERSION,
        sessionId: session.get(),
        ontruckUserId,
        country,
        country_code: country,
        ...eventData,
      });
    }
  } catch (segmentError) {
    console.error('ERROR sending event to segment', segmentError);
  }
};

export { identify, track, getSegmentWebClient };
